import { getWrapper, wrapper } from '../request';
export var listSpaces = getWrapper('themes')('listSpacesWithGroups');
export var checkSpacePermission = getWrapper('themes')('checkSpacePermission');
export var quickCreateSpace = wrapper('themes')('quickCreateSpace');
export var listUserSpaces = wrapper('themes')('listUserSpaces');
export var quickUpdateSpaceRoleMember = wrapper('themes')('quickUpdateSpaceRoleMember');